export default __webpack_public_path__ + "static/media/wrong.b9211f1f.mp3";